module.exports = __webpack_public_path__ + "static/media/2.b6b379e4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/cei/2.mp3
// module id = 474
// module chunks = 0